import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { LANGS, LANG_LABEL } from '../lib/i18n';
import { Link, NavLink } from '../lib/router';
import { useStore } from '../lib/store';
import { ScrollToTop } from './ScrollToTop';

/**
 * Знак бренда — дракон в круге.
 *
 * Файл лежит в public/logo-mark.svg. Пока его нет, знак просто не
 * показывается, а не превращается в значок битой картинки.
 */
function Mark() {
  const [failed, setFailed] = useState(false);
  if (failed) return null;
  return (
    <img
      src="/logo-mark.svg"
      alt=""
      aria-hidden="true"
      className="logo__mark"
      onError={() => setFailed(true)}
    />
  );
}

export function Layout() {
  const { lang, setLang, currency, setCurrency, t, count } = useStore();

  return (
    <>
      <ScrollToTop />
      <header className="header">
        <div className="wrap header__inner">
          <Link to="/" className="logo">
            <Mark />
            {/* Название и подпись в шапке не переводятся — это часть логотипа */}
            <span lang="en">
              Vishap
              <small>tea shop in Armenia and Worldwide</small>
            </span>
          </Link>

          <nav className="header__nav">
            <NavLink to="/about">{t.about}</NavLink>
          </nav>

          <div className="header__spacer" />

          <div className="header__actions">
            {/* Перенос строки для телефона: переключатели уходят под логотип */}
            <div className="header__break" />
            <div className="switch" role="group" aria-label="Language">
              {LANGS.map((code) => (
                <button
                  key={code}
                  type="button"
                  lang={code}
                  aria-pressed={lang === code}
                  onClick={() => setLang(code)}
                >
                  {LANG_LABEL[code]}
                </button>
              ))}
            </div>

            <div className="switch" role="group" aria-label="Валюта">
              {(['AMD', 'USD'] as const).map((code) => (
                <button
                  key={code}
                  type="button"
                  aria-pressed={currency === code}
                  onClick={() => setCurrency(code)}
                >
                  {code === 'AMD' ? '֏' : '$'}
                </button>
              ))}
            </div>

            <Link to="/cart" className="btn btn--ghost btn--small cart-badge">
              {t.cart}
              {count > 0 && <span>{count}</span>}
            </Link>
          </div>
        </div>
      </header>

      <main>
        <Outlet />
      </main>

      <footer className="footer">
        <div className="wrap footer__inner">
          <div>
            <b>Vishap Tea</b>
            <br />
            {t.location}
            <br />
            <Link to="/about">{t.about}</Link>
          </div>
          <div>
            <a href="https://t.me/vishap_tea" target="_blank" rel="noreferrer">
              Telegram
            </a>
            {' · '}
            <a href="https://instagram.com/vishap_tea" target="_blank" rel="noreferrer">
              Instagram
            </a>
          </div>
        </div>
      </footer>
    </>
  );
}
